// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2h_Fj","requiredAsterisk":"Info_requiredAsterisk__3Ww-X"};